module.exports = __webpack_public_path__ + "img/121.9a4b049c.jpg";